import { render, staticRenderFns } from "./Remissions.vue?vue&type=template&id=287686ec&"
import script from "./Remissions.vue?vue&type=script&lang=js&"
export * from "./Remissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports